<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Crear Artículo"
  [style]="{ width: '750px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="mt-2 mb-2">
          <p-fieldset legend="Grupo Terapéutico" [toggleable]="true">
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-10">
                <label>Descripción</label>
                <input
                  pInputText
                  formControlName="groupTherapists"
                  type="text"
                />
              </div>
              <div class="field col-12 md:col-2">
                <button
                  pButton
                  pRipple
                  icon="pi pi-check-square"
                  class="p-button-rounded p-button-info"
                  (click)="select.therapistGroups.openDialog = true"
                  pTooltip="Seleccionar Grupo Terapéutico"
                  tooltipPosition="left"
                ></button>
              </div>
            </div>
          </p-fieldset>
        </div>
        <div class="mt-3 mb-2">
          <p-fieldset legend="Principio Activo" [toggleable]="true">
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-10">
                <label>Descripción</label>
                <input
                  pInputText
                  formControlName="activeIngredients"
                  type="text"
                />
              </div>
              <div class="field col-12 md:col-2">
                <button
                  pButton
                  pRipple
                  icon="pi pi-check-square"
                  class="p-button-rounded p-button-info"
                  (click)="select.activeIngredients.openDialog = true"
                  pTooltip="Seleccionar Principio Activo"
                  tooltipPosition="left"
                ></button>
              </div>
            </div>
          </p-fieldset>
        </div>
        <div class="mt-3 mb-2">
          <p-fieldset
            legend="Datos"
            [toggleable]="true"
            class="mt-3 mb-2 md:mt-0"
          >
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-6">
                <label>Código</label>
                <input pInputText formControlName="code" type="text" />
              </div>
              <div class="field col-12 md:col-6">
                <label>Nombre</label>
                <input pInputText formControlName="name" type="text" />
              </div>
            </div>
          </p-fieldset>
        </div>

        <div class="p-fluid p-formgrid grid mt-3 mb-2">
          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              icon="pi pi-times"
              (click)="onClose()"
              class="p-button-text"
              label="No"
              pTooltip="Cancelar Cambios"
              tooltipPosition="top"
            ></button>
          </div>
          <div class="field col-12 md:col-2">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              icon="pi pi-check"
              class="p-button-text"
              [disabled]="fg.invalid"
              label="Si"
              tooltipPosition="top"
              pTooltip="Guardar Cambios"
            ></button>
          </div>
        </div>
      </form>
    </div></div
></p-dialog>

<pg-therapist-group-select
  *ngIf="select.therapistGroups.openDialog"
  (selectedRowsEvent)="onSelectedTherapishGroup($event)"
>
</pg-therapist-group-select>
<pg-active-ingredient-select
  *ngIf="select.activeIngredients.openDialog"
  (selectedRowsEvent)="onSelectedActiveIngredients($event)"
></pg-active-ingredient-select>
